import { Box, Typography } from '@mui/material';
import type { FC } from 'react';
import { STATUS_TONES, type EdrStatusTone } from './edrTokens';

type EdrStatusPillProps = {
  tone: EdrStatusTone;
  label: string;
  dot?: boolean;
};

export const EdrStatusPill: FC<EdrStatusPillProps> = ({ tone, label, dot = true }) => {
  const palette = STATUS_TONES[tone] ?? STATUS_TONES.neutral;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: '10px',
        bgcolor: palette.bg,
        fontSize: 11,
        fontWeight: 600,
        color: palette.color,
        textTransform: 'capitalize',
      }}
    >
      {dot ? <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: palette.color }} /> : null}
      <Typography component="span" sx={{ fontSize: 11, fontWeight: 600, color: palette.color, lineHeight: '16px' }}>
        {label}
      </Typography>
    </Box>
  );
};
